import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import { InputGroup, Button, Row, Col } from 'react-bootstrap'
import { MdHelp } from 'react-icons/md'
import Select, { components } from 'react-select'
import { FaAngleDown, FaDownload } from 'react-icons/fa'
import Swal from "sweetalert2";
import { AiFillCloseCircle, FaMinus, FaPlus } from 'react-icons/all'
import Alert from '../Alert'

import Upload from '../../models/Upload'
import Member from '../../models/Member'
import Palette from '../../Palette'
import { IconButton } from '@material-ui/core'
import Language from '../../models/Language'

export default function UpgradeMembershipModal(props) {
    let { data, show, close } = props
    const MAX_FILE_SIZE = 10 * 1024 * 1024
    console.log('isi datanya : ', data)

    const [errorMsg, setErrorMsg] = useState(null)
    const [profileAgreement, setProfileAgreement] = useState('')
    const [isPrintCard, setIsPrintCard] = useState(false)
    const [profileAgreementError, setProfileAgreementError] = useState('')
    const [termsAgreement, setTermsAgreement] = useState(false)
    const [regulationCompliance, setRegulationCompliance] = useState(false)

    //add language
    const [languageSelection, setLanguageSelection] = useState([])
    const [selectedLanguagePair, setSelectedLanguagePair] = useState([])
    const [languageFrom, setLanguageFrom] = useState(null)
    const [languageTo, setLanguageTo] = useState(null)
    const [profession, setProfession] = useState(null)

    const [translatorReqType, setTranslatorReqType] = useState(null)
    const [translatorReqFile, setTranslatorReqFile] = useState([])
    const [interpreterReqFile, setInterpreterReqFile] = useState([])
    const [mitraKtpSuratKerjaFile, setMitraKtpSuratKerjaFile] = useState([])
    const [mitraKartuAnggotaFile, setMitraKartuAnggotaFile] = useState([])

    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                const languages = await Language.getAllLanguages()

                // Filter dan urutkan bahasa
                const validLanguages = filterValidLanguages(languages)
                validLanguages.sort((a, b) => a.language.localeCompare(b.language))

                setLanguageSelection(
                    validLanguages.map((lang) => ({
                        value: lang.id,
                        label: lang.language,
                    })),
                )
            } catch (error) {
                console.error('Gagal memuat bahasa:', error)
                // Fallback data jika API gagal
                setLanguageSelection([
                    { value: 30, label: 'English' },
                    { value: 17, label: 'Indonesian' },
                    { value: 38, label: 'Japanese' },
                    { value: 32, label: 'French' },
                    { value: 48, label: 'Spanish' },
                    { value: 41, label: 'Mandarin' },
                ])
            }
        }

        fetchLanguages()

    }, [])

    useEffect(() => {
        if (Array.isArray(data?.languages)) {
            if (data?.languages?.length > 0) {
                setSelectedLanguagePair(data?.languages?.map((val) => {
                    return {
                        language_from: {
                            value: val.from_id,
                            label: val.language_from,
                        },
                        language_to: {
                            value: val.to_id,
                            label: val.language_to,
                        },
                    }
                }))
            }
        }
        setProfession(data?.member?.profession)
    }, [show])



    const filterValidLanguages = (languages) => {
        return languages.filter(
            (lang) =>
                !lang.language.includes('-----') &&
                !lang.language.startsWith('LEGACY') &&
                lang.language.trim() !== '' &&
                !lang.language.includes('--------------------------------------'),
        )
    }

    // Hapus pasangan bahasa
    const handleRemoveLanguagePair = (index) => {
        const updatedPairs = [...selectedLanguagePair]
        updatedPairs.splice(index, 1)
        setSelectedLanguagePair(updatedPairs)
    }

    // Tambah pasangan bahasa
    const handleAddLanguagePair = () => {
        if (languageFrom && languageTo) {
            // Cegah bahasa sumber dan target sama
            if (languageFrom.value === languageTo.value) {
                alert('Bahasa sumber dan target tidak boleh sama')
                return
            }

            if (languageFrom.label !== "Indonesian" && languageTo.label !== "Indonesian") {
                alert('Saat ini HPI hanya mengakui penerjemahan dengan sumber atau tujuan Bahasa Indonesia')
                return
            }

            // Cek apakah pasangan sudah ada
            const isPairExist = selectedLanguagePair.some(
                (pair) =>
                    pair.language_from.value === languageFrom.value &&
                    pair.language_to.value === languageTo.value,
            )

            if (isPairExist) {
                alert('Pasangan bahasa ini sudah ada')
                return
            }

            const newPair = {
                language_from: languageFrom,
                language_to: languageTo,
            }
            console.log('added', [...selectedLanguagePair, newPair])
            setSelectedLanguagePair([...selectedLanguagePair, newPair])
            setLanguageFrom(null)
            setLanguageTo(null)
        }
    }

    const handleFileUpload = async (e, type) => {
        const model = new Upload()

        const file = e.target.files[0]
        //console.log('ETF', file)

        if (file && file > MAX_FILE_SIZE) {
            Swal.fire(
                '',
                'Ukuran file terlalu besar. Ukuran maksimum yang diizinkan adalah 10 MB.',
                'error',
            )
            return false
        }
        const formData = new FormData()

        formData.append('upload', file)
        formData.append('member_id', '-1')

        const result = await model.uploadImage(formData)

        //console.log('cekcek', result)

        if (type === 'translator') {
            let obj = {
                id: translatorReqFile.length + 1,
                name: file.name,
                location: result?.location,
            }
            setTranslatorReqFile([...translatorReqFile, obj])
        } else if (type === 'interpreter') {
            let obj = {
                id: interpreterReqFile.length + 1,
                name: file.name,
                location: result?.location,
            }
            setInterpreterReqFile([...interpreterReqFile, obj])
        } else if (type === 'mitraKtpSuratKerja') {
            let obj = {
                id: mitraKtpSuratKerjaFile.length + 1,
                name: file.name,
                location: result?.location,
            }
            setMitraKtpSuratKerjaFile([...mitraKtpSuratKerjaFile, obj])
        } else if (type === 'mitraKartuAnggota') {
            let obj = {
                id: mitraKartuAnggotaFile.length + 1,
                name: file.name,
                location: result?.location,
            }
            setMitraKartuAnggotaFile([...mitraKartuAnggotaFile, obj])
        }
    }

    const DropdownIndicator = (props) => {
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <FaAngleDown color={'grey'} />
                </components.DropdownIndicator>
            )
        )
    }

    const PROFESSION_OPTIONS = [
        { value: 'Translator', label: 'Penerjemah' },
        { value: 'Interpreter', label: 'Juru bahasa' },
        { value: 'Both', label: 'Keduanya' },
    ]

    const upgrade = async () => {
        let payload = {};
        let fileRegistInterpreter = interpreterReqFile?.map((v) => {
            return v.location
        });
        let fileRegistTranslator = translatorReqFile?.map((v) => {
            return v.location
        });

        if (!profession) {
            Swal.fire('', 'Harap memilih profesi', 'error')
            return
        }

        if (selectedLanguagePair.length === 0) {
            Swal.fire('', 'Harap memilih pasangan bahasa', 'error')
            return
        }
        switch (profession) {
            case "Translator":
                if (translatorReqFile?.length === 0) {
                    Swal.fire('', 'Harap unggah pemenuhan Syarat Penerjemah', 'error')
                    return
                }
                payload.file_registration_requirements_type = translatorReqType
                payload.file_registration_requirements = fileRegistTranslator
                break;
            case "Interpreter":
                if (interpreterReqFile?.length === 0) {

                    Swal.fire('', 'Harap unggah pemenuhan syarat Juru Bahasa', 'error')
                    return
                }
                payload.file_reference_letter_interpreter = fileRegistInterpreter
                break
            default:
                if (translatorReqFile?.length === 0) {
                    Swal.fire('', 'Harap unggah pemenuhan Syarat Penerjemah', 'error')
                    return
                }

                if (interpreterReqFile?.length === 0) {

                    Swal.fire('', 'Harap unggah pemenuhan syarat Juru Bahasa', 'error')
                    return
                }

                payload.file_registration_requirements_type = translatorReqType
                payload.file_registration_requirements = [...fileRegistTranslator]
                payload.file_reference_letter_interpreter = [...fileRegistInterpreter]
        }

        if (profileAgreement.length === 0) {
            Swal.fire('', 'Harap pilih Pernyataan kebersediaan menampilkan profile', 'error')
            return
        }
        if (!termsAgreement) {
            Swal.fire('', 'Harap setujui Pernyataan Kepatuhan Terhadap Peraturan Organisasi', 'error')
            return
        }
        if (!regulationCompliance) {
            Swal.fire('', 'Harap setujui Pernyataan Keterikatan Dengan Syarat & Ketentuan HPI yang Berlaku', 'error')
            return
        }

        try {
            let model = new Member();
            payload.is_print = isPrintCard
            payload.is_public = profileAgreement;
            payload.profession = profession;
            payload.languages = selectedLanguagePair?.map((val) => {
                return {
                    from_id: val.language_from.value,
                    to_id: val.language_to.value
                }
            })

            console.log('cek payload', payload)

            const swalResult = await Swal.fire({
                title: 'Apakah Anda yakin akan mengirim pengajuan ini?',
                text: 'Harap klik konfirmasi untuk proses selanjutnya',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, lanjutkan',
                cancelButtonText: 'Batal'
            });

            if (swalResult.isConfirmed) {
                Swal.fire({
                    title: 'Memproses...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
          
                let result = await model.upgradeMembership(payload);
                if (result?.payment?.snap_payment_url) {
                    window.location.href = result.payment.snap_payment_url;
                    return;
                } else {
                    await Swal.fire({
                        title: 'Informasi Peningkatan Status Saudara telah tersimpan',
                        text: 'Mohon menunggu, pengajuan peningkatan status Saudara sedang kami proses.',
                        icon: 'success',
                        confirmButtonText: 'OKE',
                    });
                    window.location.reload();
                    close();
                }
            }
        } catch (e) {
            console.error(e);
            await Swal.fire({
                title: 'Terjadi Kesalahan',
                text: e.error_message || 'Terjadi kesalahan saat memproses permintaan Anda',
                icon: 'error',
                confirmButtonText: 'OKE',
            });
        }

    }


    const TRANSLATOR_REQ_OPTIONS = [
        {
            label: '1. Telah menerjemahkan buku dan diterbitkan oleh penerbit terdaftar IKAPI',
            value: '1',
        },
        {
            label: '2. Melampirkan contoh terjemahan (beserta teks sumber) dengan volume 150.000 karakter termasuk spasi',
            value: '2',
        },
        { label: '3. Merupakan Penerjemah Tersumpah (SK Mentri)', value: '3' },
        { label: '4. Merupakan Penerjemah Tersumpah (SK Gubernur DKI Jakarta)', value: '4' },
        {
            label: '5. Telah bekerja (minimal) satu tahun di sebuah perusahaan sebagai penerjemah atau jabatan terkait penerjemah',
            value: '5',
        },
        { label: '6. Surat rujukan/referensi dari 3(tiga) klien yang berbeda', value: '6' },
    ]

    const reset = () => {
        setRegulationCompliance(false)
        setProfileAgreement(false)
        setProfession('')
        setTermsAgreement(false)
        setSelectedLanguagePair([])
        setLanguageFrom(null)
        setLanguageTo(null)
        setIsPrintCard(null)

        setTranslatorReqType('1')
        setTranslatorReqFile([])
        setInterpreterReqFile([])
        setMitraKtpSuratKerjaFile([])
        setMitraKartuAnggotaFile([])

        close()
    }

    return (
        <Modal show={show} onHide={() => reset()} size={'lg'}>
            <Modal.Header closeButton>Syarat Peningkatan Status Keanggotaan</Modal.Header>
            <Modal.Body>
                <Container>
                    {errorMsg ? <Alert type="error" className='mx-0' errorMsg={errorMsg}></Alert> : null}


                    <div className="register-form-label mb-3">
                        <span className='heading-title'>
                            Profesi
                        </span>

                    </div>
                    <InputGroup className="mb-4">
                        <div style={{ display: 'grid', gap: '10px', width: '100%' }}>
                            {PROFESSION_OPTIONS.map((option) => (
                                <div
                                    key={option.value}
                                    style={{ display: 'flex', alignItems: 'center' }}
                                >
                                    <input
                                        type="radio"
                                        name="profession"
                                        checked={profession === option.value}
                                        onChange={() => {
                                            console.log('option selected', option)
                                            setProfession(option.value)
                                        }}
                                        style={{ marginRight: '10px' }}
                                    />
                                    {option.label}
                                </div>
                            ))}
                        </div>
                    </InputGroup>


                    <>
                        {(profession === 'Translator' || profession === 'Both') && (
                            <>
                                <div className="register-form-label mb-3">
                                    <span className='heading-title'>
                                        SYARAT PENDAFTARAN SEBAGAI ANGGOTA PROFESIONAL (PENERJEMAH) - Pilih
                                        Satu
                                    </span>
                                </div>

                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text
                                            style={{
                                                borderWidth: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                backgroundColor: '#e9f3f4',
                                            }}
                                        >
                                            <MdHelp size={20} />
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>

                                    <div style={{ flex: 1 }}>
                                        <Select
                                            className="form-control-custom"
                                            value={
                                                TRANSLATOR_REQ_OPTIONS.find(
                                                    (opt) => opt.value === translatorReqType,
                                                ) || TRANSLATOR_REQ_OPTIONS[0]
                                            }
                                            onChange={(option) =>
                                                setTranslatorReqType(option.value)
                                            }
                                            options={TRANSLATOR_REQ_OPTIONS}
                                            styles={{
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    cursor: 'pointer',
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderWidth: 0,
                                                    backgroundColor: '#e9f3f4',
                                                    fontFamily: 'Signika',
                                                    fontWeight: '600',
                                                    color: '#8e8e8e',
                                                }),
                                            }}
                                            components={{
                                                DropdownIndicator,
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                    </div>
                                </InputGroup>

                                <div className="register-form-label mb-3">
                                    <span className='heading-title'>
                                        Pemenuhan Syarat -{' '}
                                    </span>

                                    {TRANSLATOR_REQ_OPTIONS.find(
                                        (opt) => opt.value === translatorReqType,
                                    )?.label || TRANSLATOR_REQ_OPTIONS[0].label}
                                </div>

                                <div>
                                    <label className="btn btn-sm btn-secondary" htmlFor="translatorReq">
                                        Unggah
                                    </label>
                                    <input
                                        style={{ display: 'none' }}
                                        id="translatorReq"
                                        type="file"
                                        onChange={(e) => handleFileUpload(e, 'translator')}
                                    />
                                </div>

                                <Row>
                                    <Col md={12}>
                                        {translatorReqFile &&
                                            translatorReqFile?.map((values, key) => {
                                                return (
                                                    <>
                                                        <a
                                                            href={values.location}
                                                            alt=""
                                                            target="_blank"
                                                        >
                                                            <Button variant="link">
                                                                {values.name}
                                                            </Button>
                                                        </a>
                                                        <a
                                                            className="text-secondary mr-4"
                                                            onClick={(e) => {
                                                                let filtered =
                                                                    translatorReqFile?.filter(
                                                                        (v, key) => {
                                                                            return v?.id !== values?.id
                                                                        },
                                                                    )
                                                                setTranslatorReqFile(filtered)
                                                            }}
                                                            href="javascript:;"
                                                        >
                                                            <AiFillCloseCircle />
                                                        </a>
                                                    </>
                                                )
                                            })}
                                    </Col>
                                </Row>
                            </>
                        )}

                        {(profession === 'Interpreter' || profession === 'Both') && (
                            <>
                                <div className="register-form-label required mt-3 mb-3">
                                    <span className='heading-title'>SYARAT PENDAFTARAN SEBAGAI ANGGOTA PROFESIONAL (JURU BAHASA) - Surat
                                    rujukan/referensi dari 3 (tiga) klien yang berbeda (dengan
                                    mencantumkan nama, alamat, dan nomor yang dapat dihubungi) yang
                                    menunjukkan bahwa Saudara telah melakukan pekerjaan yang memuaskan
                                    sebagai juru bahasa dengan total jam kerja minimal 500 (lima ratus)
                                    jam.</span>
                                </div>

                                <Button onClick={() => {
                                    const filePath = '/SUKET_Pelaksanaan_Kerja_Penjurubahasaan.docx';
                                    const link = document.createElement('a');
                                    link.href = filePath;
                                    link.download = 'SUKET_Pelaksanaan_Kerja_Penjurubahasaan.docx';
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }} style={{ borderColor: Palette.PRIMARY, background: Palette.PRIMARY, color: '#fff' }} variant='primary'>
                                    <div style={{ gap: 4 }} className='d-flex align-items-center g-2'>
                                        <FaDownload />
                                       Unduh template surat keterangan

                                    </div>
                                </Button>

                                <div>
                                    <label
                                        className="btn btn-sm btn-secondary mt-4"
                                        htmlFor="interpreterReq"
                                    >
                                        Unggah
                                    </label>
                                    <input
                                        style={{ display: 'none' }}
                                        id="interpreterReq"
                                        type="file"
                                        onChange={(e) => handleFileUpload(e, 'interpreter')}
                                    />
                                </div>

                                <Row>
                                    <Col md={12}>
                                        {interpreterReqFile &&
                                            interpreterReqFile?.map((value, key) => {
                                                return (
                                                    <>
                                                        <a
                                                            href={value?.location}
                                                            alt=""
                                                            target="_blank"
                                                        >
                                                            <Button variant="link">
                                                                {value?.name}
                                                            </Button>
                                                        </a>

                                                        <a
                                                            className="text-secondary mr-4"
                                                            onClick={(e) => {
                                                                let filtered =
                                                                    interpreterReqFile?.filter(
                                                                        (v, key) => {
                                                                            return v?.id !== value?.id
                                                                        },
                                                                    )
                                                                setInterpreterReqFile(filtered)
                                                            }}
                                                            href="javascript:;"
                                                        >
                                                            <AiFillCloseCircle />
                                                        </a>
                                                    </>
                                                )
                                            })}
                                    </Col>
                                </Row>
                            </>
                        )}
                    </>


                    <div className="mt-3 mb-3 register-form-label">
                        <span className='heading-title'>
                            PERNYATAAN KEBERSEDIAAN UNTUK MENAMPILKAN PROFIL DI DIREKTORI PENERJEMAH DAN
                            JURU BAHASA INDONESIA JIKA DITERIMA SEBAGAI ANGGOTA PROFESIONAL
                        </span>
                    </div>

                    <div style={{ display: 'grid' }}>
                        <div>
                            <input
                                name="profile_agreement"
                                type="radio"
                                value={true}
                                onClick={() => {
                                    setProfileAgreement(true)
                                    setProfileAgreementError(false)
                                }}
                            />{' '}
                            Saya Bersedia
                        </div>
                        <div>
                            <input
                                name="profile_agreement"
                                type="radio"
                                value={false}
                                onClick={() => {
                                    setProfileAgreement(false)
                                    setProfileAgreementError(false)
                                }}
                            />{' '}
                            Saya Tidak Bersedia
                        </div>
                    </div>
                    {profileAgreementError && <Alert type="error" className='mx-0' errorMsg={'Bagian ini harus diisi'}></Alert>}


                    {/* Pasangan Bahasa */}
                    <div className="register-form-label mt-3">
                        <span className='heading-title'>
                            Pasangan Bahasa
                        </span>

                    </div>
                    <InputGroup className="mb-4">
                        <Col className="px-0">
                            <Container fluid>
                                {/* Daftar pasangan bahasa yang sudah dipilih */}
                                {selectedLanguagePair.length > 0 ? (
                                    selectedLanguagePair.map((pair, idx) => (
                                        <Row key={idx} style={{ marginBottom: 15 }}>
                                            <Col
                                                xs={5}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {pair.language_from.label}
                                            </Col>
                                            <Col
                                                xs={1}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {'>'}
                                            </Col>
                                            <Col
                                                xs={5}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {pair.language_to.label}
                                            </Col>
                                            <Col
                                                xs={1}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <IconButton
                                                    size={'small'}
                                                    onClick={() => handleRemoveLanguagePair(idx)}
                                                    style={{ backgroundColor: Palette.PRIMARY }}
                                                >
                                                    <FaMinus size={'12'} color={'white'} />
                                                </IconButton>
                                            </Col>
                                        </Row>
                                    ))
                                ) : (
                                    <Row style={{ marginBottom: 15 }}>
                                        <Col
                                            xs={12}
                                            style={{ textAlign: 'center', color: '#6c757d' }}
                                        >
                                            Belum ada pasangan bahasa yang dipilih
                                        </Col>
                                    </Row>
                                )}

                                {/* Form tambah pasangan bahasa baru */}
                                <Row>
                                    <Col xs={5}>
                                        <Select
                                            placeholder={'Pilih Bahasa Sumber'}
                                            value={languageFrom}
                                            onChange={(option) => setLanguageFrom(option)}
                                            options={languageSelection}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderColor: '#e6e6e6',
                                                }),
                                            }}
                                            components={{ DropdownIndicator }}
                                            isClearable
                                        />
                                    </Col>
                                    <Col
                                        xs={1}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {'>'}
                                    </Col>
                                    <Col xs={5}>
                                        <Select
                                            placeholder={'Pilih Bahasa Target'}
                                            value={languageTo}
                                            onChange={(option) => setLanguageTo(option)}
                                            options={languageSelection}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderColor: '#e6e6e6',
                                                }),
                                            }}
                                            components={{ DropdownIndicator }}
                                            isClearable
                                        />
                                    </Col>
                                    <Col
                                        xs={1}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <IconButton
                                            size={'small'}
                                            onClick={handleAddLanguagePair}
                                            style={{ backgroundColor: Palette.PRIMARY }}
                                            disabled={!languageFrom || !languageTo}
                                        >
                                            <FaPlus size={'12'} color={'white'} />
                                        </IconButton>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </InputGroup>

                    <Row direction="column">
                        <div className="register-form-label mt-4 mb-3">
                            <span className='heading-title'>
                                Pernyataan Kepatuhan Terhadap Peraturan Organisasi
                            </span>
                        </div>
                        <div
                            style={{
                                padding: '15px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '5px',
                                // marginBottom: '20px',
                                display: 'flex',
                                alignItems: 'flex-start',
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={regulationCompliance || false}
                                onChange={(e) => setRegulationCompliance(e.target.checked)}
                                style={{
                                    marginRight: '10px',
                                    marginTop: '3px',
                                    cursor: 'pointer',
                                    width: '16px',
                                    height: '16px',
                                }}
                            />
                            <label
                                style={{
                                    fontSize: '0.9rem',
                                    lineHeight: '1.4',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                }}
                            >
                                Apabila saya diterima sebagai Anggota Profesional Himpunan Penerjemah
                                Indonesia (HPI), saya bersedia mematuhi semua aturan HPI, termasuk
                                AD/ART dan Kode Etik dan Kode Perilaku Profesi Penerjemah dan Juru
                                Bahasa, dan saya bersedia menerima sanksi apa pun yang dikenakan kepada
                                diri saya apabila saya terbukti melanggar aturan tersebut, termasuk
                                pembekuan dan/atau penghentian status keanggotaan saya di HPI, dan saya
                                tidak akan mengajukan gugatan, tuntutan, dan/atau mengambil tindakan
                                hukum apa pun terhadap Badan Pengurus HPI dan/atau anggota Badan
                                Pengurus HPI secara perorangan dan/atau secara organisasi.
                            </label>
                        </div>
                    </Row>

                    <Row direction="column">
                        <div className="register-form-label mt-4 mb-3">
                            <span className='heading-title'>
                                Pernyataan Keterikatan Dengan Syarat & Ketentuan HPI yang Berlaku
                            </span>
                        </div>
                        <div
                            style={{
                                padding: '15px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'flex-start',
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={termsAgreement || false}
                                onChange={(e) => setTermsAgreement(e.target.checked)}
                                style={{
                                    marginRight: '10px',
                                    marginTop: '3px',
                                    cursor: 'pointer',
                                    width: '16px',
                                    height: '16px',
                                }}
                            />
                            <label
                                style={{
                                    fontSize: '0.9rem',
                                    lineHeight: '1.4',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                }}
                            >
                                Dengan mengisi dan mengirim formulir pengajuan ini kepada HPI, saya
                                menyatakan diri saya terikat pada Syarat dan Ketentuan yang berlaku di
                                HPI.
                            </label>
                        </div>
                    </Row>


                    <Row>

                        <div className="register-form-label mt-4 mb-3">
                            <span className='heading-title'>
                                Pernyataan Persetujuan Percetakan Kartu Keanggotaan
                            </span>
                        </div>
                        <div
                            style={{
                                padding: '15px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '5px',
                                marginBottom: '20px',
                            }}
                        >
                            <p style={{ marginBottom: '15px', fontSize: '0.9rem' }}>
                                Kami menyediakan opsi pencetakan kartu keanggotaan bagi Anda yang ingin
                                memiliki bukti fisik keanggotaan. Biaya pencetakan kartu yang akan
                                dikenakan adalah sebesar Rp100.000
                            </p>

                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <input
                                    type="checkbox"
                                    checked={isPrintCard || false}
                                    onChange={(e) => {
                                        console.log('isi checked', e.target.checked)
                                        setIsPrintCard(e.target.checked)
                                    }}
                                    style={{
                                        marginRight: '10px',
                                        marginTop: '3px',
                                        cursor: 'pointer',
                                        width: '16px',
                                        height: '16px',
                                    }}
                                />
                                <label
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.4',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                    }}
                                >
                                    Dengan mencentang opsi ini, saya setuju untuk mencetak kartu
                                    keanggotaan saya
                                </label>
                            </div>
                        </div>
                    </Row>




                    <Button style={{ background: Palette.PRIMARY }} onClick={upgrade} className='w-100 mt-4'>
                        Ajukan
                    </Button>
                </Container>
            </Modal.Body>
        </Modal>
    )
}
